import combineUrlAndParams from 'authorization-module/helpers/combineUrlAndParams'
import formatAuthRequest from 'authorization-module/helpers/formatAuthRequest'
import { RedirectToAuthProps } from 'authorization-module/helpers/typings'
import { mockAuthData } from 'mocks/mockData'

/**
 * Function to simulate the authorization module's redirectToMockAuth function
 * Takes in all the same args and does a window replace redirect just like
 * the global auth server would, passing a mock id token
 * @param {object} authConfig Object containing the following values:
 * @param {string} authConfig.baseURL Global auth server domain
 * @param {string} authConfig.clientId Apigee developer app id
 * @param {string} authConfig.redirectURI Consumer application callback url
 * @param {string} authConfig.loginHintURL IDP login page url
 * @param {string} authConfig.[scope] An optional param - Auth token scope
 * @param {string} authConfig.[navigateTo] An optional param - consumer application sends the user to either home or different path ex., deep linking
 * @param {boolean} redirect An optional param - Wether it should redirect to authorizeLoginURL
 */
const redirectToMockAuth = (
  authConfig: RedirectToAuthProps,
  redirect = true
): void => {
  // using the actual auth module flow to generate the appropriate session values
  const { oauthRedirectUri, requestBodyQueryParams } =
    formatAuthRequest(authConfig)
  const mockRedirectURL = combineUrlAndParams(
    oauthRedirectUri,
    requestBodyQueryParams
  )
  // eslint-disable-next-line no-console
  console.log(
    `This is where we would have redirected to for OAuth: ${mockRedirectURL}`
  )
  // eslint-disable-next-line no-console
  console.log(
    `Auth server would process the request and 302 redirect to a signin page with a idToken: ${authConfig.loginHintURL}`
  )

  if (redirect) {
    // just like the auth server, do a window location replace type redirect
    window.location.replace(mockAuthData.authorizeLoginURL)
  }
}

export default redirectToMockAuth
